import Constants from '@/Constants';
import { EntityType } from '@/models/EntityTypes';
import { openModal } from '@/store/common/actions';
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import MoreOptionsModal from '../ContentMoreOptions/Modal/MoreOptionsModal';
import MarkAsCompleted from '../MarkAsCompletedSection';
import Rating from '../Rating';
import './style.scss';

export interface SideMenuScrollOptionsAttr {
    hashLink: string;
    iconName: string;
}

export interface SideMenuScrollEntityTypeOptions {
    [x: string]: SideMenuScrollOptionsAttr[];
}

interface Props {
    entityType: EntityType;
    conclude?: boolean;
    rating?: boolean;
    moreOptions?: ReactElement;
    isMenuFixed?: boolean;
}

const SideMenu: React.FC<Props> = (props: Props) => {
    const { entityType, moreOptions, conclude, rating, isMenuFixed } = props;
    const dispatch = useDispatch();

    const showMoreOptions = (event: React.FormEvent) => {
        event.stopPropagation();
        event.preventDefault();
        dispatch(openModal({ id: Constants.modal.MORE_OPTIONS, layoutModal: moreOptions, isVisible: true, isCloseAllowed: true }));
    };

    return (
        <div className="col-sm-1">
            <div className={`side-menu${isMenuFixed ? '-fixed' : '-floating'}`}>
                <div className="side-menu__inner">
                    {moreOptions && (
                        <div className="side-menu__inner-section-options">
                            <div className="border-line" />
                            <MoreOptionsModal modalId={Constants.modal.MORE_OPTIONS} />
                            <a className="side-menu__item side-menu__options" href="" onClick={showMoreOptions}>
                                <span className="material-icons side-menu__icon">{Constants.icons.MORE_HORIZ}</span>
                            </a>
                        </div>
                    )}

                    <div>
                        {conclude && (
                            <div className="side-menu__inner-section">
                                <MarkAsCompleted />
                            </div>
                        )}

                        {rating && (
                            <div className="side-menu__inner-section">
                                <Rating entityType={entityType} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideMenu;
